import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import Button from 'app/components/button';
import Checkbox from 'app/components/checkbox';
import Dropdown from 'app/components/Dropdown';
import MultiSelectDropdown from 'app/components/MultiSelectDropdown';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import ModuleTable from './ModuleTable';
import CustomTable from './table';
import useCreatePermission from './useCreatePermission';
import Loader from 'app/components/Loader';

const CreatePermission = () => {
  const {
    pageLoading,
    navigate,
    handleChange,
    values,
    error,
    rolesList,
    moduleList,
    mallList,
    parentMallOptions,
    permissionList,
    handleDelete,
    handleRolesSelection,
    handleModulesSelection,
    handleParentMallChange,
    handleSaveParentMalls,
    handleCreatePermission,
  } = useCreatePermission();

  return (
    <>
      <div className='blogsForm'>
        <div className='blogsForm_content'>
          <div className='content-container__actionBox'>
            <div className='content-container__filterSearch'>
              <HeaderWithBackButton
                title={'Permission'}
                goTo={APP_CONSTANTS.USERS}
              />
            </div>
          </div>

          <div className='inner-form-wrapper flex justify-between flex-wrap mt-4 '>
            <div className='wd-50'>
              <Dropdown
                id={'mallId'}
                label='Mall name*'
                name='mallId'
                options={mallList}
                placeholder='Select Mall '
                value={values.mallId}
                handleChange={handleChange}
                errorText={error?.mallId}
              />
            </div>
            <div className='wd-50'>
              <MultiSelectDropdown
                id='parentMalls'
                label='Parent Mall (privilege visibility)'
                name='parentMalls'
                options={parentMallOptions}
                value={values.parentMalls}
                onChange={handleParentMallChange}
              />
              {/* Parent-mall visibility saves on its own — no Mall/Role needed. */}
              <div className='d-flex justify-content-between align-items-center flex-wrap gap-2 mt-2'>
                <small className='text-muted'>
                  Limits this admin to privileges of customers from the selected
                  mall(s). Leave empty for no restriction.
                </small>
                <Button
                  className='mt1'
                  onClick={handleSaveParentMalls}
                  variant='Save'
                  name='Save Parent Malls'
                />
              </div>
            </div>
            <div className='wd-100'>
              <label className='me-2 d-inline-block tooltip-on-hover'>
                Select Roles*
              </label>
              <div className='d-flex'>
                {rolesList?.map((item, index) => {
                  return (
                    <Checkbox
                      id={item?.id}
                      label={item?.name}
                      checked={item?.checked}
                      onChange={handleRolesSelection}
                    />
                  );
                })}
              </div>
              <div>
                {error.roleId && (
                  <p className='loginWrapper-valid-text'>{error.roleId}</p>
                )}
              </div>
            </div>

            <div className='wd-100'>
              <ModuleTable
                data={moduleList}
                handleModulesSelection={handleModulesSelection}
              />
            </div>
          </div>
          <div className='d-flex justify-content-start mt-2 mb-2'>
            <Button
              className='mt1'
              onClick={handleCreatePermission}
              variant='Save'
              name={'Submit'}
            />
            <Button
              className='mt1 cancel-button ms-2'
              onClick={() => navigate(`${APP_CONSTANTS.USERS}`)}
              variant='Cancel'
              name='Cancel'
            />
          </div>
          <CustomTable
            data={permissionList}
            getContentDataHandler={handleDelete}
          />
        </div>
      </div>
      {pageLoading && <Loader pageLoading={pageLoading} />}
    </>
  );
};

export default CreatePermission;
